export default __webpack_public_path__ + "static/media/ecommerce-bg.5fe9eaad.png";